import { render, staticRenderFns } from "./BtnExcluirMeta.vue?vue&type=template&id=432144e6"
import script from "./BtnExcluirMeta.vue?vue&type=script&lang=js"
export * from "./BtnExcluirMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports